<template>
	<div class="basic-container">
		<div>
			<div class="tool-box mobile-hide">
				<div>
					<button type="button" name="addRow" class="greenBtn tiny" @click="openAddReportPopup()" v-if="!isCompany">+추가</button>
				</div>
			</div>
			<section class="table-area">
				<div class="table-header mobile-hide" ref="table">
					<div class="col-auto">구분</div>
					<div>제목</div>
					<div class="col-date">등록일</div>
				</div>
				<!-- web -->
				<article class="table-list mobile-hide" v-for="(reportVO, i) in reportMetaObjList" v-bind:key="i">
					<div class="col-auto mobile-hide">{{ reportVO.REPORT_TYPE_NM }}</div>
					<div class="mobile-hide">
						<a @click="openAddReportPopup({ reportSeqNo: reportVO.REPORT_SEQ_NO, reportType: reportVO.REPORT_TYPE, popupType: 'detail' })">
							{{ reportVO.REPORT_TITLE }}
						</a>
					</div>
					<div class="col-date mobile-hide">{{ reportVO.REPORT_REG_DATE }}</div>
				</article>
				<!--   mobile   -->
				<article class="table-list web-hide" v-for="(reportVO, i) in reportMetaObjList" v-bind:key="'reportMetaObjList_mobile_' + i">
					<div class="col-title">
						<a @click="openAddReportPopup({ reportSeqNo: reportVO.REPORT_SEQ_NO, reportType: reportVO.REPORT_TYPE, popupType: 'detail' })">
							{{ reportVO.REPORT_TITLE }}
						</a>
					</div>
					<div class="col-date col-line">
						<a @click="openAddReportPopup({ reportSeqNo: reportVO.REPORT_SEQ_NO, reportType: reportVO.REPORT_TYPE, popupType: 'detail' })">
							{{ reportVO.REPORT_TYPE_NM }}
						</a>
					</div>
					<div class="col-date">
						<a @click="openAddReportPopup({ reportSeqNo: reportVO.REPORT_SEQ_NO, reportType: reportVO.REPORT_TYPE, popupType: 'detail' })">
							{{ reportVO.REPORT_REG_DATE }}
						</a>
					</div>
				</article>
			</section>
		</div>
	</div>
</template>

<script>
import eventBus from '@/plugins/event-bus';
import CONST from '@/constants';

export default {
	title: '보고서 목록',
	name: 'ReportList',
	props: ['matchSeqNo', 'reportYm', 'reportMetaObjList'],
	data: function() {
		return {
			loginMember: null,
			isTableResize: false,
		};
	},
	created() {
		eventBus.$emit(CONST.EVENTS.SET_SIDE_MENU, 'BIZ');
		let dt = this.$device.loadLocalData('LOGIN_USER');
		if (dt) this.loginMember = JSON.parse(dt);
	},
	mounted() {},
	computed: {
		isCompany: function() {
			return this.loginMember && this.loginMember.budsUserType === CONST.USER_TYPE.COMPANY;
		},
	},
	methods: {
		openAddReportPopup: function(data) {
			let REPORT_TITLE = '보고서 추가';
			let body = document.getElementsByTagName('body')[0];
			body.classList.add('not-scroll');
			let param = {};
			if (data) {
				param = data;
				REPORT_TITLE = '보고서 수정';
			}
			eventBus.$emit(CONST.EVENTS.OPEN_MODAL, 'modalMainMonthlyReport', REPORT_TITLE, param);
		},
	},
};
</script>

<style scoped></style>
